__turbopack_context__.v({
  "root": "DetailList-module__b_WIqa__root",
  "rootInline": "DetailList-module__b_WIqa__rootInline",
});
